import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyC5_4pf2YY2bxXlyW7ymj7Bhx3UGtiR77E',
  authDomain: 'rabs-connect-lite.firebaseapp.com',
  projectId: 'rabs-connect-lite',
  storageBucket: 'rabs-connect-lite.firebasestorage.app',
  messagingSenderId: '344010736193',
  appId: '1:344010736193:web:9a2267c28e9c7078efbcc0',
  measurementId: 'G-HL3CDQ1LPJ',
};

const VAPID_KEY = 'BP58ZIPP6B1OePpd2vIKenYk2AogURrwDVgb6nJstv6pqJbaGOZY1gRpppmf4POhXlijy9dp5aru1oiMpWEgyQQ';

const app = initializeApp(firebaseConfig);

let messaging = null;
try {
  messaging = getMessaging(app);
} catch (e) {}

/**
 * Request notification permission and get FCM token
 */
export const requestNotificationPermission = async () => {
  try {
    if (!messaging) return null;

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
    });

    return token;
  } catch (err) {
    return null;
  }
};

/**
 * Listen for foreground messages
 */
export const onForegroundMessage = (callback) => {
  if (!messaging) return () => {};
  return onMessage(messaging, (payload) => {
    callback(payload);
  });
};

export { messaging };
